import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { FilterActionTypes, useFilter } from '../../redux_toolkit/V3/Filter'
import { useLoader } from '../../redux_toolkit/Loader'
import {
    generateSharedCollectionPageParams,
    sharedCollectionFields
} from '../filter/filterUtil'
import {
    authUserInfo,
    isPageReachBottom,
    isPickAndChooseBuyer,
    sharedCollectionCardRenderSequence
} from '../../helpers/Util'
import {
    useCollectionResponseList,
    useSharedCollections
} from '../../redux_toolkit/V3/SharedCollection'
import SharedCollectionThunk from '../../redux_toolkit/V3/SharedCollection/SharedCollectionThunk'
import {
    GET_ALL_SHARED_COLLECTION,
    GET_ALL_SHARED_COLLECTION_STYLE_WISE
} from '../../redux_toolkit/@types/thunk.types'
import SingleItemCollection from './components/SingleItemCollection'
import TwoItemCollection from './components/TwoItemCollection'
import ThreeItemCollection from './components/ThreeItemCollection'
import FourItemCollection from './components/FourItemCollection'
import BreadCrumb from '../common/BreadCrumb'
import FilterComponent from '../filter/FilterComponent'

import { CLEAR_FILTER_FIELDS } from '../../redux_toolkit/@types/action.types'
import useDocumentTitle from '../../hooks/userDocumentTitle'
import { ReactComponent as SelectedCardViewIcon } from '../../../assets/icons/grid-view-active.svg'
import { ReactComponent as CollectionUnFillIcon } from '../../../assets/icons/collection-unfill.svg'
import { ReactComponent as CollectionViewFillIcon } from '../../../assets/icons/collection-view-fill.svg'
import { ReactComponent as CollectionViewUnfillIcon } from '../../../assets/icons/collection-view-unfill.svg'
import SharedCollectionStyleView from './SharedCollectionStyleView'
import { fetchFilterFieldsThunk } from '../../redux_toolkit/V3/Filter/FilterOptionThunks'

const SharedCollection = () => {
    const [collections, setCollections] = useState([])
    const [designList, setDesignList] = useState([])
    const [collectionResponseList, setCollectionResponseList] = useState([])
    const sharedCollections = useSharedCollections()
    const collectionResponse = useCollectionResponseList()
    const [viewType, setViewType] = useState('COLLECTION_VIEW')
    const isLoading = useRef(null)
    const viewTypeRef = useRef('COLLECTION_VIEW')
    const globalLoader = useLoader()
    const filterStore = useFilter()
    const dispatch = useDispatch()
    const scrollRef = useRef()
    useDocumentTitle('Nitex - Collections')

    useEffect(() => {
        dispatch(
            fetchFilterFieldsThunk({
                fieldsType: sharedCollectionFields,
                isExploreDesignPage: true
            })
        )
    }, [])

    const setIsDataLoading = (data) => {
        isLoading.current = data
    }

    useEffect(() => {
        setIsDataLoading(globalLoader)
    }, [globalLoader])

    const generateParams = (pageNumber) => {
        return `${
            authUserInfo().id
        }?page=${pageNumber}&memberType=SHARED&size=20&sort=members.sharedAt,desc`
    }

    const generateParamsForStyleView = (pageNumber) => {
        return `${
            authUserInfo().id
        }/style-view?page=${pageNumber}&memberType=SHARED&size=20&sort=members.sharedAt,desc`
    }

    const fetchSharedCollections = (pageNumber) => {
        const requetBody = generateSharedCollectionPageParams(filterStore)
        if (viewTypeRef.current === 'COLLECTION_VIEW') {
            dispatch(
                SharedCollectionThunk[GET_ALL_SHARED_COLLECTION](
                    generateParams(pageNumber),
                    requetBody
                )
            )
        } else {
            dispatch(
                SharedCollectionThunk[GET_ALL_SHARED_COLLECTION_STYLE_WISE](
                    generateParamsForStyleView(pageNumber),
                    requetBody
                )
            )
        }
    }

    useEffect(() => {
        document.addEventListener('scroll', handleScroll)
        return () => {
            document.removeEventListener('scroll', handleScroll)
        }
    }, [])

    useEffect(() => {
        fetchSharedCollections(0)
    }, [filterStore, viewType])

    const handleScroll = () => {
        if (isPageReachBottom()) {
            let { totalElements, currentPage, data } = scrollRef.current

            if (
                totalElements > 0 &&
                totalElements !== data.length &&
                !isLoading.current
            ) {
                fetchSharedCollections(currentPage + 1)
            }
        }
    }

    useEffect(() => {
        if (viewType === 'COLLECTION_VIEW') {
            setCollections(sharedCollections?.data)
        } else {
            setCollectionResponseList(collectionResponse)
            setDesignList(sharedCollections?.data)
        }

        scrollRef.current = sharedCollections
    }, [sharedCollections])

    const getCollectionCard = (item, collectionList) => {
        if (item === 1) {
            return <SingleItemCollection collections={collectionList} />
        } else if (item === 2) {
            return <TwoItemCollection collections={collectionList} />
        } else if (item === 3) {
            return <ThreeItemCollection collections={collectionList} />
        } else if (item === 4) {
            return <FourItemCollection collections={collectionList} />
        }
    }

    const renderCollections = () => {
        if (collections?.length > 0) {
            let sequenceArray = sharedCollectionCardRenderSequence(
                collections.length
            )
            let startingPosition = 0
            let endingPosition = 0
            return sequenceArray?.map((item, i) => {
                endingPosition = startingPosition + item
                let collectionList = collections.slice(
                    startingPosition,
                    endingPosition
                )
                startingPosition = endingPosition
                return (
                    <React.Fragment key={`collection_card_${i}`}>
                        {getCollectionCard(item, collectionList)}
                    </React.Fragment>
                )
            })
        }
    }

    const onChangeViewType = (type) => {
        setViewType(type)
        viewTypeRef.current = type
        dispatch(FilterActionTypes[CLEAR_FILTER_FIELDS]())
    }

    const getBuyerWiseFilterFields = (sharedCollectionFields) => {
        return !isPickAndChooseBuyer()
            ? (({ PRICE_RANGE, ...rest }) => rest)(sharedCollectionFields)
            : sharedCollectionFields
    }

    return (
        <>
            <div className='flex justify-between py-3'>
                <BreadCrumb isShowBackButton={false} />
            </div>
            <FilterComponent
                requiredFields={getBuyerWiseFilterFields(
                    sharedCollectionFields
                )}
                filteredDataLength={collections?.length}
            >
                <button
                    className='button !p-0 min-w-[44px]'
                    onClick={() => onChangeViewType('COLLECTION_VIEW')}
                >
                    {viewType === 'COLLECTION_VIEW' ? (
                        <CollectionViewFillIcon className='!w-[44px] !h-[44px]' />
                    ) : (
                        <CollectionViewUnfillIcon className='!w-[44px] !h-[44px]' />
                    )}
                </button>
                <button
                    className='button !p-0 min-w-[44px]'
                    onClick={() => onChangeViewType('CARD_VIEW')}
                >
                    {viewType === 'CARD_VIEW' ? (
                        <SelectedCardViewIcon className='!w-[44px] !h-[44px]' />
                    ) : (
                        <CollectionUnFillIcon className='!min-w-[24px] !min-h-[24px]' />
                    )}
                </button>
            </FilterComponent>
            <div className='shared-collections py-5 px-4'>
                {viewType === 'COLLECTION_VIEW' ? (
                    renderCollections()
                ) : (
                    <SharedCollectionStyleView
                        designList={designList}
                        collectionResponseList={collectionResponseList}
                        setDesignList={setDesignList}
                        setCollectionResponseList={setCollectionResponseList}
                    />
                )}
                {collections?.length === 0 && (
                    <div className='epmpty-state py-40 text-center m-auto'>
                        <h3 className='text-xl weight-700 gray_400'>
                            No collection share yet
                        </h3>
                    </div>
                )}
            </div>
        </>
    )
}

export default SharedCollection
